import type { InstructorCue, InstructorState } from './types';

export function stateForCue(cue:InstructorCue,minimized=false):InstructorState{
  if(minimized||cue.mode==='minimized')return 'minimized';
  if(cue.mode==='summary')return 'summarising';
  if(cue.mode==='encouragement'||cue.mode==='quiz-intro')return 'encouraging';
  if(cue.mode==='warning'||cue.pose==='serious')return 'serious';
  if(cue.pose==='point-left')return 'pointing-left';
  if(cue.pose==='point-right')return 'pointing-right';
  if(cue.pose==='thinking')return 'thinking';
  return cue.pose==='idle'?'idle':'speaking';
}
